import { render, staticRenderFns } from "./MonitoringPV.vue?vue&type=template&id=561bab96&scoped=true"
import script from "./MonitoringPV.vue?vue&type=script&lang=js"
export * from "./MonitoringPV.vue?vue&type=script&lang=js"
import style0 from "./MonitoringPV.vue?vue&type=style&index=0&id=561bab96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561bab96",
  null
  
)

export default component.exports